export const CREATE_BUSINESS_PROFILE_SUCCESS =
  'zehitomo/users/auth/CREATE_BUSINESS_PROFILE_SUCCESS';

export const REGISTER_CLIENT_SUCCESS = 'zehitomo/users/auth/REGISTER_CLIENT_SUCCESS';
export const REGISTER_PRO_SUCCESS = 'zehitomo/users/auth/REGISTER_PRO_SUCCESS';

export const UPLOAD_AVATAR_SUCCESS = 'zehitomo/users/auth/UPLOAD_AVATAR_SUCCESS';
